import { useEffect, useState } from 'react'
import { useUser } from '../../contexts/UserContext'
import { API_CONFIG } from '../../config/apiConfig'

/**
 * 管理后台跳转中间页
 * 管理员点击「管理后台」按钮后跳转到此页面，
 * 页面加载后自动在新标签页打开 GCS-PC 管理后台，然后返回首页
 *
 * M1改造:
 * - GCS-PC URL 从 API_CONFIG 动态获取（支持测试/生产环境切换）
 * - 增加 loading 超时保护：5s 后自动返回首页
 */
export default function AdminRedirect() {
    const { isAdmin } = useUser()
    const [hasOpened, setHasOpened] = useState(false)

    useEffect(() => {
        // 非管理员不允许访问，返回上一页
        if (!isAdmin) {
            window.history.back()
            return
        }

        if (hasOpened) return
        setHasOpened(true)

        // 从 API_CONFIG 动态获取 GCS-PC URL，如无则使用默认值
        const gcsPcUrl = API_CONFIG.gcsPcUrl || 'https://mvs.synwaylink.com/co/work/main'
        window.open(gcsPcUrl, '_blank')

        // M1: 超时保护 — 5s 后无论是否跳转成功都返回首页
        const timeoutId = setTimeout(() => {
            window.history.back()
        }, 5000)

        return () => clearTimeout(timeoutId)
    }, [isAdmin, hasOpened])

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
        }}>
            <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid #f0f0f0',
                borderTop: '3px solid #3370ff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: '16px'
            }} />
            <p style={{ color: '#666', fontSize: '14px' }}>正在跳转管理后台...</p>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    )
}
